import { useApi } from "@/lib/api";
import { GridSkeleton, ProductGrid, StoreNotice } from "@/components/ProductCard";
import { MaskLines, Reveal } from "@/components/Reveal";

const Listing = ({ eyebrow, title, description, products, loading, error, testid }) => (
  <section className="mx-auto max-w-[1600px] px-4 pb-28 pt-14 md:px-8 md:pt-20">
    <div className="mb-12 border-b pb-6 md:mb-16">
      <p className="label text-[#111111]/60">{eyebrow}</p>
      <h1 className="mt-4 text-6xl font-extrabold uppercase leading-[0.85] tracking-[-0.07em] sm:text-7xl lg:text-[9rem]">
        <MaskLines lines={[title]} delay={0.1} />
      </h1>
      <div className="mt-6 flex flex-wrap items-end justify-between gap-4">
        {description ? <p className="max-w-lg text-sm leading-relaxed text-[#111111]/75">{description}</p> : <span />}
        {!loading && !error && <p data-testid="listing-count" className="label text-[#111111]/60">{products.length} {products.length === 1 ? "piece" : "pieces"}</p>}
      </div>
    </div>
    {loading && <GridSkeleton n={8} />}
    {error && <StoreNotice error={error} />}
    {!loading && !error && (
      products.length ? <Reveal><ProductGrid products={products} testid={testid} /></Reveal> : <p className="label py-16 text-center text-[#111111]/60">No products yet</p>
    )}
  </section>
);

export function ShopPage() {
  const { data, loading, error } = useApi("/shop/products?first=100");
  return <Listing eyebrow="Shop" title="All Pieces" products={Array.isArray(data) ? data : []} loading={loading} error={error} testid="shop-grid" />;
}
